import { MagnifyingGlass, X } from "@phosphor-icons/react";

/**
 * Compact search input styled to match the app's neo-brutalist sharp-edged look.
 * Filters by Job No. or Client Name (partial, case-insensitive) — matching logic
 * lives in the consuming page.
 */
export default function SearchBar({
  value,
  onChange,
  placeholder = "Search by Job No. or Client Name…",
  testId = "search-bar-input",
  className = "",
}) {
  return (
    <div className={`relative flex-1 min-w-0 sm:max-w-sm ${className}`}>
      <MagnifyingGlass
        size={14}
        weight="bold"
        className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400 pointer-events-none"
      />
      <input
        data-testid={testId}
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label="Search by Job No. or Client Name"
        className="w-full h-10 pl-9 pr-9 bg-white border border-zinc-300 focus:border-zinc-900 focus:outline-none font-mono text-sm placeholder:text-zinc-400 placeholder:font-sans placeholder:italic"
      />
      {value && (
        <button
          type="button"
          data-testid={`${testId}-clear`}
          onClick={() => onChange("")}
          aria-label="Clear search"
          className="absolute right-2.5 top-1/2 -translate-y-1/2 text-zinc-400 hover:text-zinc-900 p-0.5"
        >
          <X size={13} weight="bold" />
        </button>
      )}
    </div>
  );
}

/**
 * Case-insensitive partial matcher — returns true if haystack contains needle,
 * or needle is empty/whitespace.
 */
export function matchesSearch(needle, ...haystacks) {
  const q = (needle || "").trim().toLowerCase();
  if (!q) return true;
  return haystacks.some((h) => (h || "").toString().toLowerCase().includes(q));
}
